export const getUsedFieldIds = fieldsets => {
    const ids = [];
    const visit = fields => (fields || []).forEach(field => {
        if (field.id) ids.push(field.id);
        if (field.fields) visit(field.fields);
        if (field.fieldsets) field.fieldsets.forEach(fieldset => visit(fieldset.fields));
    });
    (fieldsets || []).forEach(fieldset => visit(fieldset.fields));
    return ids;
};

export const getPluginFieldOptions = ({fields, groupLabel, entity}) => fields.map(field => {
    const id = `${entity}.${field.id}`;
    return {
        id,
        value: id,
        label: field.label,
        defaultLabel: field.label,
        controlType: field.type,
        group: {label: groupLabel},
        fieldDefaults: {...field, id, name: id, fixedFieldId: id, customFieldName: false, fieldName: null}
    };
});
